<app-button
  variant="primary"
  classes="px-4"
  type="button"
  dataTestid="reload-application-button"
  (click)="onClick($event)"
  *ngIf="isAdmin"
>
  {{ buttonText }}
</app-button>

<div
  class="font-size-primary text-unselectable col-md-3 px-0 mt-2"
  *ngIf="!isAdmin"
>
  <a
    href="#"
    class="button dark d-block text-center py-3 w-100"
    data-testid="reload-application-button"
    (click)="onClick($event)"
  >
    {{ buttonText }}
  </a>
</div>
